import {
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "../fetchOrchestrators";

type IAnyState =
  | IFtthOrchestrator["state"]
  | IMobileOrchestrator["state"]
  | IMultiOrderOrchestrator["state"];

const ftthInProgressStates = new Set<IAnyState>([
  "CONTRACT_VERIFICATION",
  "IDENTITY",
  "IDENTITY_ERROR",
  "IDENTITY_PENDING",
  "IDENTITY_FULLSTOP",
  "PAYMENT_METHOD",
  "APPOINTMENT",
  "ORDER_SUMMARY",
  "ORDER_PAYMENT",
  "ORDER_PAYMENT_ERROR",
  "ORDER_FULFILLMENT",
  "ORDER_HELD",
  "ORDER_FINISHING",
  "ORDER_PENDING_CANCELLATION",
  "ORDER_COMMITTED",
  "ORDER_PENDING_CANCELLATION",
]);

const mobileInProgressStates = new Set<
  | IMobileOrchestrator["state"]
  | IFtthOrchestrator["state"]
  | IMultiOrderOrchestrator["state"]
>([...ftthInProgressStates, "DELIVERY", "ITEM_SELECTION"]);

export function onboardingInProgress(
  state: IAnyState,
  type:
    | IFtthOrchestrator["type"]
    | IMobileOrchestrator["type"]
    | IMultiOrderOrchestrator["type"],
) {
  if (
    type === "NJU_MOBILE_ONBOARDING" ||
    type === "NJU_MULTIORDER_ONBOARDING"
  ) {
    return state && mobileInProgressStates.has(state);
  }
  return state && ftthInProgressStates.has(state);
}
